var chunkToChildrenMap = {
	"37547": [
		89240,
		8689,
		70075,
		46512,
		38495,
		9924,
		60448,
		91956,
		60918
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));